// extracted by mini-css-extract-plugin
export var closed = "header-module--closed--609a0";
export var opened = "header-module--opened--3996a";
export var toggle = "header-module--toggle--51ec6";
export var topLogo = "header-module--top-logo--aeb9b";
export var topLogo__btn = "header-module--top-logo__btn--13a9c";
export var topLogo__link = "header-module--top-logo__link--4cecd";
export var topLogo__linkWrapper = "header-module--top-logo__link-wrapper--f8a72";
export var topLogo__logo = "header-module--top-logo__logo--89e35";
export var topLogo__navigation = "header-module--top-logo__navigation--93895";